module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Impala - TAILORED TRAVEL PROGRAMS, EXCEPTIONAL SAVINGS","short_name":"Impala - TAILORED TRAVEL PROGRAMS, EXCEPTIONAL SAVINGS","start_url":"/","background_color":"#28bbc7","theme_color":"#28bbc7","display":"standalone","icon":"src/images/icon.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"328ccf7c419eac106ff5902ff74b7904"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
